import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface EconomicMetricsInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.NPV'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.IRR'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.UIRR'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.SPP'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.DPP'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.PI'?: ResultRow;
}
export class EconomicMetrics {
  'RESULTS.DATA.ECONOMIC_METRICS.NPV';
  'RESULTS.DATA.ECONOMIC_METRICS.IRR';
  'RESULTS.DATA.ECONOMIC_METRICS.UIRR';
  'RESULTS.DATA.ECONOMIC_METRICS.SPP';
  'RESULTS.DATA.ECONOMIC_METRICS.DPP';
  'RESULTS.DATA.ECONOMIC_METRICS.PI';

  /** net present value */
  get npv() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.NPV'];
  }
  set npv(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.NPV'] = value;
  }
  /** levered IRR (internal rate of return) */
  get irr() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.IRR'];
  }
  set irr(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.IRR'] = value;
  }
  /** unlevered IRR (internal rate of return) */
  get uirr() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.UIRR'];
  }
  set uirr(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.UIRR'] = value;
  }
  /** simple payback period */
  get spp() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.SPP'];
  }
  set spp(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.SPP'] = value;
  }
  /** discounted payback period */
  get dpp() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.DPP'];
  }
  set dpp(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.DPP'] = value;
  }
  /** profitability index */
  get pi() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.PI'];
  }
  set pi(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.PI'] = value;
  }

  constructor(param: EconomicMetricsInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.NPV'] = param['RESULTS.DATA.ECONOMIC_METRICS.NPV']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.NPV'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.IRR'] = param['RESULTS.DATA.ECONOMIC_METRICS.IRR']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.IRR'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.UIRR'] = param['RESULTS.DATA.ECONOMIC_METRICS.UIRR']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.UIRR'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.SPP'] = param['RESULTS.DATA.ECONOMIC_METRICS.SPP']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.SPP'])
      : new ResultRow()

    this['RESULTS.DATA.ECONOMIC_METRICS.DPP'] = param['RESULTS.DATA.ECONOMIC_METRICS.DPP']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.DPP'])
      : new ResultRow()

    this['RESULTS.DATA.ECONOMIC_METRICS.PI'] = param['RESULTS.DATA.ECONOMIC_METRICS.PI']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.PI'])
      : new ResultRow()
  }

  deepCopy() {
    return new EconomicMetrics(cloneDeep(this));
  }
}